import { createContext, useContext } from 'react';
import type { User } from '@/types';

export interface ProfileInfoItem {
  label: string;
  value: string;
}

export interface AccountLayoutContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  showEditForm: boolean;
  setShowEditForm: (show: boolean) => void;
  handleAvatarChange: (file: File) => Promise<void>;
  handleAvatarRemove: () => Promise<void>;
  profileInfoItems: ProfileInfoItem[];
  isMobile: boolean;
}

export const AccountLayoutContext = createContext<AccountLayoutContextType | undefined>(undefined);

export function useAccountContext() {
  const ctx = useContext(AccountLayoutContext);
  if (!ctx) throw new Error('useAccountContext must be used within AccountLayout');
  return ctx;
}
